import React from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useLoading } from '../../providers/loading_provider'
import { useSnackBar } from '../../providers/snack_bar_provider'
import {
  ApiErrorResponse,
  getKyousouApiClient,
  handleError,
} from '../../services/network'
import FlatButton from '../../components/buttons/flat_button'
import AuthLayout from '../../components/layouts/auth_layout'
import MainBackground from '../../images/main_bg.png'

type PasswordResetRequestFormProps = {
  email: string
}

const PasswordResetRequestPage: React.FC = () => {
  const { showLoading, hideLoading } = useLoading()
  const navigate = useNavigate()
  const { showSnackBar } = useSnackBar()
  const kyousouApiClient = getKyousouApiClient()

  const { register, handleSubmit, formState } =
    useForm<PasswordResetRequestFormProps>({
      defaultValues: {
        email: '',
      },
      mode: 'onSubmit',
    })

  const { errors } = formState

  const passwordResetRequest = async (data: PasswordResetRequestFormProps) => {
    showLoading()
    try {
      await kyousouApiClient.password.resetSendCreate({
        email: data.email,
      })
      navigate('/password/reset/send', { state: { email: data.email } })
    } catch (e) {
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      hideLoading()
    }
  }

  return (
    <AuthLayout>
      <div
        className="min-h-screen flex flex-col justify-center items-center bg-cover bg-center bg-no-repeat p-4"
        style={{
          backgroundImage: `url(${MainBackground})`,
        }}
      >
        <div className="bg-white rounded-xl w-full max-w-xl p-6">
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-center mb-8">
              パスワードリセット
            </h1>
            <p className="text-left">
              ご登録しているメールアドレスを入力してください。
              <br />
              入力したメールアドレス宛にパスワードリセットのURLを送信します。
            </p>
          </div>

          <form onSubmit={handleSubmit(passwordResetRequest)}>
            <p className="mb-2 font-bold text-left">メールアドレス</p>
            {errors.email && (
              <p className="text-main-red text-sm mt-1 mb-1">
                {errors.email.message}
              </p>
            )}
            <input
              className="w-full mb-2 py-1 px-2 border border-black rounded-lg outline-none"
              type="email"
              placeholder="メールアドレスを入力してください"
              {...register('email', {
                required: 'メールアドレスは必須です',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: '有効なメールアドレスを入力してください',
                },
              })}
            />

            <FlatButton type="submit" className="w-full mt-8">
              送信
            </FlatButton>
          </form>
        </div>
      </div>
    </AuthLayout>
  )
}

export default PasswordResetRequestPage
